module.exports = __webpack_public_path__ + "img/market-solution.8fce75ec.webp";